/**
 * 男女性别分类占比组件
 */

import { useEffect, useState } from 'react';
import { message } from 'antd';
import $ from 'jquery';
import {
    UjoinParams,
    AddRequestHeaders,
} from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

import RTypePercent from '../../components/RTypePercent.js';

const UserUDSXC = (props) => {
    const [isRefresh, setIsRefresh] = useState(true);
    const [orgInfosLists, setOrgInfosLists] = useState([]);
    const [orgInfoULID, setOrgInfoULID] = useState('');
    const [data, setData] = useState([]);

    useEffect(() => {
        /**
         * 获取组织下拉列表
         * props.data为真，则是通过Chat调用传数据
         */
        if (!props.data && !orgInfosLists.length) {
            $.ajax({
                url: `${CNF.api}org/infos?rss=list`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setOrgInfosLists(data.dat);
                            setOrgInfoULID(data.dat[0].key);
                            setIsRefresh(true);//  刷新数据
                        }
                    } else {
                        message.error(data.msg);
                    }
                }
            })
        }
    }, [props.data, orgInfosLists.length])

    useEffect(() => {
        if (props.data) {
            setData(props.data);
        } else {
            if (isRefresh && orgInfoULID) {
                //  获取数据
                const params = {
                    'org_info_ulid': orgInfoULID,
                }
                $.ajax({
                    url: `${CNF.api}reports/user/udsxc${UjoinParams(params)}`,
                    headers: AddRequestHeaders(),
                    crossDomain: true,
                    type: 'GET',
                    dataType: 'JSON', success: function (data) {
                        if (data.res === 0) {
                            if (data.dat.length > 0) {
                                setData(data.dat);
                            } else {
                                setData([]);
                            }
                            setIsRefresh(false);
                        } else {
                            message.error(data.msg, CNF.messageDuration);
                        }
                    }
                })
            }
        }
    }, [props, data, isRefresh, orgInfoULID]);

    return <RTypePercent data={data} title='男女性别分类占比' subtitle='展示男女性别人才结构占比，使用百分比。' />
}

export default UserUDSXC;